import styled from '@emotion/styled';

export const SideContentWrapper = styled.div`
  border-radius: 10px;
  padding: 25px;
  padding-top: 0;
  position: relative;
  background: ${(props) => props.theme.color.light.default};
`;

export const SideContentHeader = styled.div`
  background: ${(props) => props.theme.color.blue.default};
  color: ${(props) => props.theme.color.light.default};
  border-radius: 10px 10px 0 0;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);
  margin: 0px -25px 10px;
  padding: 14px 25px;
  font-size: 16px;
  position: relative;
  &::after {
    border-color: ${(props) => props.theme.color.blue.default} transparent transparent;
    border-style: solid;
    border-width: 6px 6px 0;
    bottom: -6px;
    content: '';
    display: block;
    height: 0;
    left: 50%;
    margin-left: -6px;
    margin-top: 0;
    position: absolute;
    top: auto;
    transform: rotate(1turn);
    width: 0;
  }
`;

export const SideContentTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
`;

export const MapContainer = styled.div`
  height: 400px;
  margin-top: 30px;
  margin-bottom: 10px;
  position: relative;
  zindex: 0;
`;

export const RelatedLinksContainer = styled.div`
  margin-top: 50px;
`;

export const ShareWrapper = styled.div`
  margin-top: 8px;
`;
